<!--
 * @Author: likk
 * @Date: 2023-09-05 14:59:22
 * @LastEditTime: 2024-03-22 07:42:49
 * @LastEditors: likk 1126919170@qq.com
 * @Description: 预约机手弹框
-->
<template>
  <el-dialog title="预约机手" :visible.sync="visible" width="1200px" :destroy-on-close="true" class="dialog-bg">
    <el-form ref="filterForm" :inline="true" :model="filterForm">
      <el-form-item prop="checkedWorkArea" label="地区">
        <el-cascader :options="regionData" :props="props" v-model="filterForm.checkedWorkArea"
          popper-class="region-wrap" collapse-tags  clearable placeholder="请选择作业地区"></el-cascader>
      </el-form-item>
      <el-form-item prop="checkedWorkType" label="作业类型">
        <el-cascader
          :options="workTypeTree"
          :props="workTypeProps"
          v-model="filterForm.checkedWorkType"
          clearable
          placeholder="请选择作业类型"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleFilter()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="multipleTable" :data="tableData" :max-height="450" @selection-change="handleSelectionChange" :row-key="getRowKey" v-loading="loading" tooltip-effect="custom-tooltip-style">
      <el-table-column type="selection" width="55" :selectable="handleSelectable" :reserve-selection="true"></el-table-column>
      <el-table-column prop="ownerName" label="服务方名称" align="center" min-width="12%"></el-table-column>
      <el-table-column prop="workTypeNames" label="作业类型" align="center" min-width="20%" show-overflow-tooltip></el-table-column>
      <el-table-column prop="workAreaNames" label="作业区域" align="center" min-width="18%" show-overflow-tooltip></el-table-column>
      <el-table-column prop="workAddress" label="所在位置" align="center" min-width="20%"></el-table-column>
      <el-table-column label="操作" align="center" min-width="8%">
        <template slot-scope="{row}">
          <el-button type="text" @click="handleDetail(row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next,jumper"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :current-page="pagination.pageNum"
      :hide-on-single-page="true"
      @current-change="handleFilter"
    >
    </el-pagination>
    <div class="foot">
      <el-button type="primary" @click="handleSubmit()">预约</el-button>
      <el-button type="primary" @click="visible = false;" class="btn-gray">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import regionSeatLibs from 'utils/regionSeatLibs'
  let regionData = JSON.parse(JSON.stringify(regionSeatLibs[0].c))
  import { workTypeTree,workServiceList,reservationServer } from "@/api/gxInfo" 
  export default {
    // props:{
    //   workDemandId:{
    //     type:String,
    //     default:''
    //   }
    // },
    data(){
      return {
        visible:false,
        workDemandId:'',//
        regionData,
        props: {
          value: 'i',
          label: 'n',
          children: 'c'
        },
        workTypeTree:[],//作业类型数据
        workTypeProps:{
          value: 'code',
          label: 'name',
          children: 'children'
        },
        filterForm:{
          checkedWorkArea:[],//作业地区，
          checkedWorkType:[],//作业类型
        },
        tableData:[],
        pagination: {
          pageNum: 1,
          pageSize: 10,
          total: 0,
        },
        checkedData:[],//选中的表格数据
        loading:false,

      }
    },
    watch:{
      visible:{
        handler(val){
          if(val){
            this.handleFilter(1);
          }else{
            this.$refs.filterForm.resetFields();
            this.tableData = [];
            this.checkedData = [];
          }
        }
      }
    },
    created(){
      this.getWorkTypes();
    },
    methods:{
      init(workDemandId){
        this.visible = true;
        this.workDemandId = workDemandId;
      },
      /**
       * @Author: likk
       * @description: 获取作业类型
       * @param {*}
       * @return {*}
       */ 
      async getWorkTypes(){
        let { data: {result} } = await workTypeTree();
        this.workTypeTree = result || [];
       
      },  
      /**
       * @Author: likk
       * @description: 查询
       * @param {Number} page 页码
       * @return {*}
       */ 
      handleFilter(page=1){
        this.pagination.pageNum = page
        this.getList();
      },  
      /**
       * @Author: likk
       * @description: 获取作业服务列表
       * @param {*}
       * @return {*}
       */ 
      async getList(){
        try {
          this.loading = true;
          let { checkedWorkType,checkedWorkArea } = this.filterForm;
          let {data}  = await workServiceList({
            workType:checkedWorkType[checkedWorkType.length-1],
            workProvinceId:checkedWorkArea[0] || '',
            workCityId:checkedWorkArea[1] || '',
            workCountyId:checkedWorkArea[2] || '',
            workDemandId:this.workDemandId,
            currentPage:this.pagination.pageNum,
            pageSize:this.pagination.pageSize
          });
          this.loading = false;
          this.tableData = data.content;
          this.pagination.total = data.recordTotal;
          // // 默认选中
          // this.$nextTick(() => {
          //   let checkedIds = this.checkedData.map( item => item.id);
          //   this.tableData.forEach(row => {
          //     if(checkedIds.includes(row.id)){
          //       console.log("m默认选中-row",row.ownerName)
          //       this.$refs.multipleTable.toggleRowSelection(row,true);
          //     }
          //   });
          // })
          
        } catch (error) {
          console.log(error);
          this.loading = false;
        }
      },   
      getRowKey(row){
        return row.id
      },
      /**
       * @Author: likk
       * @description: 多选
       * @param {*}
       * @return {*}
       */      
      handleSelectionChange(val){
        this.checkedData = val
      },
      /**
       * @Author: likk
       * @description: 表格数据是否可勾选
       * @param {*}
       * @return {*}
       */
       handleSelectable(row){
          return (row.isReservation!=1 ? true : false);
       },      
      /**
       * @Author: likk
       * @description: 查看
       * @param {*}
       * @return {*}
       */  
      handleDetail(id){
        this.$router.push({
          path:'/gx-query/service/detail',
          query:{id}
        })
      },
      /**
       * @Author: likk
       * @description: 发布
       * @param {*}
       * @return {*}
      */    
      handleSubmit(){
        let params = this.checkedData.map( item => {
          return {
            workServerId:item.id,
            workDemandId:this.workDemandId,
            owerUserId:item.ownerId
          } 
        })
        reservationServer({data:params}).then( () => {
          this.$message.success('预约成功');
          this.visible = false;
          this.$emit("onSuccess")
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-dialog{
    .el-table{
      ::v-deep .el-table-column--selection{
        .cell{
          padding-left: 10px;
          padding-right: 10px;
        }
      }
    }
    .foot{
      text-align: center;
      padding-top: 20px;
      .el-button{
        font-size: 20px;
        padding: 16px 48px;
        margin: 0 12px;
        &.btn-gray{
          background: #CDCDCD;
          border-color: #CDCDCD;
        }
      }
    }
  }
</style>
<style lang="scss">
  .el-tooltip__popper.is-custom-tooltip-style{
    background: #303133;
    color: #FFFFFF;
    max-width: 95vw;
    // display: -webkit-box;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // -webkit-line-clamp: 10;
    // -webkit-box-orient: vertical;
    // &:before{
    //   height: 10px;
    //   background: #303133;
    //   content:"";
    //   position: absolute;
    //   left: 0;
    //   right: 0;
    //   bottom: 0;
    // }
  }
</style>